/*jshint esversion:6 */
import React from "react";
import Select from "react-select";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Constants from "../../../configurations/constants";
import Permissions from "../../../configurations/permissions";
import ArbiterApi from "../../../api/ArbiterApi";
import SettingsConfigTable from "./settingsConfigTable";
import SettingsConfigModal from "./settingsConfigModal";


class SettingsConfigPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      settingsTypes: [],
      settingType: null,
      settingsConfig: [],
      selectedSettingsConfig:null,
      totalCount: 0,
      loading: false,
      pages: 0,
      openModalFlag: false,
      createFlag: false,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pageNum: 0 //Zero based index
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.onNewButtonClick = this.onNewButtonClick.bind(this);
    this.handleSettingTypeFilterChange = this.handleSettingTypeFilterChange.bind(this);
    this.paginateid = this.paginateid.bind(this);
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    // const idx = parseInt(index, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  componentDidMount() {
    //Get Settings Types
    ArbiterApi.getSettingsConfigTypes()//change to correct api
      .then(response => {
        let settingsTypes = response.data.map(settingType => {
          return { label: settingType, value: settingType };
        });

        this.setState({ settingsTypes });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.SETTINGS_CONFIG_TYPES}`,
          ""
        ]);
      });

    //Load data on mount
    this.reloadSettingsConfig();
  }

  onNewButtonClick(evt) {
    this.setState({ openModalFlag: true, createFlag: true });
  }
  handleSettingTypeFilterChange(evt) {
    this.setState({ settingType: evt, pageNum: 0 }, () =>
      this.reloadSettingsConfig()
    );
  }


  render() {
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Settings Configuration" />
        <Divider />
        <div className="mini-filter">
          <div className="right">
            <br />
            <button onClick={this.onNewButtonClick} className="btn btn-primary">
              + New Settings Configuration
            </button>
          </div>
          <div className="filter-select">
            <label className="input-control-label">Setting Type</label>
            <Select
              placeholder="Settings Type"
              onChange={this.handleSettingTypeFilterChange}
              options={this.state.settingsTypes}
              value={this.state.settingType}
            />
          </div>
        </div>
        <SettingsConfigTable
          onRowClick={this.onRowClick}
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          settingsConfig={this.state.settingsConfig}
          paginatedCallBack={this.paginateid}
        />
        {this.state.openModalFlag && (
          <SettingsConfigModal
            isNew={this.state.createFlag}
            isOpen={this.state.openModalFlag}
            onRequestClose={this.handleCloseModal}
            settingsConfig={this.state.selectedSettingsConfig}
          />
        )}
      </div>
    );
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.loadSettingsConfig(params);
    }
  }

  loadSettingsConfig(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;

    let settingType = this.state.settingType;
    let settingsEndpoint = "getSettingsConfig"

    if (settingType && settingType.value) {
      settingType = settingType.value;
      settingsEndpoint = "getSettingsConfigByType"
    }

    ArbiterApi[settingsEndpoint](params, settingType)
      .then(response => {
        //todo! check if api returns actuall content
        let data = response.data.content;
        let totalCount = response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0)
          Toaster.warning("No records found.", "Settings Config");
        this.setState({
          settingsConfig: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount, ///make sure totalcount is passed
          pages: pages
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [` ${Messages.ERROR_SETTINGS_CONFIG_FETCH}`]);
        this.setState({ loading: false });
      });
  }

  onRowClick(index) {
    this.setState({
      selectedSettingsConfig: this.state.settingsConfig[index],
      openModalFlag: true,
      createFlag: false
    });
  }
  handleCloseModal(event, reloadDataFlag) {
    this.setState({
      selectedSettingsConfig: null,
      openModalFlag: false,
      createFlag: false
    });
    if (reloadDataFlag) {
      this.reloadSettingsConfig();
    }
  }

  reloadSettingsConfig() {
    this.setState({ settingsConfig: [] });
    this.loadSettingsConfig({ pageSize: this.state.pageSize });
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(SettingsConfigPage, [Permissions.VIEW_SETTINGS_CONFIG]) //change permission to settings config
);



// WEBPACK FOOTER //
// ./src/components/admin/settingsConfig/settingsConfigPage.js